<ng-container *ngIf="room$ | async | ready as room">
  <app-banner
    *ngIf="
      (showOptimizationDefectiveBanner$ | async) && (devicesStore.isSelectedDeviceOBNG$ | async)
    "
    [type]="bannerType.warning"
    isFullWidth="true"
    [title]="'+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION_DEFECTIVE_BANNER.TITLE' | translate"
  >
    {{ '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION_DEFECTIVE_BANNER.DESCRIPTION' | translate }}
  </app-banner>
  <app-feature-details-grid>
    <app-feature-list-container>
      <!-- rooms.n.sensors.temperature -->
      <app-feature-list-item
        data-at-room-sensor-temperature
        *ngIf="sensorTemperature$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.CURRENT_ROOM_TEMPERATURE' | translate"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [timestamp]="feature.timestamp | date: 'short'"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- rooms.n.geofencing -->
      <ng-container *ngIf="geofencing$ | async | ready as feature">
        <app-feature-list-item
          data-at-room-geofencing
          *ngIf="feature.properties?.active?.value"
          [label]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.GEOFENCING' | translate"
          [value]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.GEOFENCING_ACTIVE' | translate"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
      </ng-container>

      <!-- rooms.n.sensors.humidity -->
      <app-feature-list-item
        data-at-room-sensor-humidity
        *ngIf="sensorHumidity$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.ROOM_HUMIDITY' | translate"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [timestamp]="feature.timestamp | date: 'short'"
        [error]="feature | error"
      >
      </app-feature-list-item>

      <!-- co2 sensor actual PPM -->
      <ng-container *ngIf="(co2SensorDevices$ | async).length > 0">
        <app-feature-list-item
          *ngIf="sensorCo2$ | async | ready as feature"
          [error]="feature | error"
          [label]="'+INSTALLATIONS.SRC.AIR_QUALITY_SENSOR.ACTUAL_PPM' | translate"
          [value]="
            feature.properties[featurePropertyKey.value]
              ? (feature | value2: featurePropertyKey.value) + ' ' + (feature | unit: 'value')
              : NO_VALUE
          "
          [attr.data-feature]="feature.feature"
          timestamp="{{ feature.timestamp | date: 'short' }}"
        >
        </app-feature-list-item>
      </ng-container>

      <!--Target temperature-->
      <!--rooms.0.quickmodes.manual/perceivedTemperature-->
      <!--rooms.0.temperature.levels.*.perceived/temperature-->
      <app-feature-list-item
        *ngIf="targetTemperature$ | async | ready as feature"
        [label]="'+INSTALLATIONS.SRC.ETRV.TARGET_TEMPERATURE' | translate"
        [error]="feature | error"
        [timestamp]="feature.timestamp | date: 'short'"
        [attr.data-feature]="feature.feature"
        value="{{
          feature
            | value2
              : (isHavingTemperatureProperty
                  ? featurePropertyKey.temperature
                  : featurePropertyKey.perceivedTemperature)
        }} {{
          feature
            | unit
              : (isHavingTemperatureProperty
                  ? featurePropertyKey.temperature
                  : featurePropertyKey.perceivedTemperature)
        }}"
      ></app-feature-list-item>

      <!-- Target room temperature -->
      <!-- rooms.n.operating.programs.[normal/reduced/comfort/manual]Heating -->
      <app-feature-list-item
        data-at-room-set
        *ngIf="heating$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.SRC.TARGET_ROOM_TEMPERATURE' | translate"
        [error]="feature | error"
        [isNgContent]="true"
        [editable]="true"
        [timestamp]="feature.timestamp | date: 'short'"
        [attr.data-feature]="feature.feature"
      >
        <ng-container
          *ngIf="
            (levelsCooling$ | async | ready) || (levelsHeating$ | async | ready);
            else operatingPrograms
          "
        >
          <div *ngIf="targetRoomTemperature$ | async | ready as targetTemperature; else noValue">
            {{ feature | value2: featurePropertyKey.temperature }}
            {{ feature | unit: featurePropertyKey.temperature }}
          </div>
          <ng-template #noValue>
            <div>{{ NO_VALUE }}</div>
          </ng-template>
        </ng-container>

        <ng-template #operatingPrograms>
          <div>
            <div>
              {{ feature | value2: featurePropertyKey.temperature }}
              {{ feature | unit: featurePropertyKey.temperature }}
            </div>
          </div>
        </ng-template>

        <mat-icon
          class="edit-icon"
          appSrcModalManager="src-temperature-schedule-manager"
          [room]="room"
          (click)="selectRoom()"
          gtm="onOpen"
          gtmAction="Multiple days selection dialog"
          gtmCategory="room"
        >
          edit
        </mat-icon>
      </app-feature-list-item>

      <!-- rooms.n.operating.programs.[normal/reduced/comfort/manual]Cooling -->
      <ng-container *ngIf="cooling$ | async | ready as feature">
        <app-feature-list-item
          data-at-room-cooling
          [label]="'+INSTALLATIONS.INSTALLATION.SRC.COOLING_TEMPERATURE' | translate"
          value="{{ feature | value2: featurePropertyKey.temperature }} {{
            feature | unit: featurePropertyKey.temperature
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
      </ng-container>

      <!-- active operating program -->
      <app-feature-list-item
        data-at-program
        *ngIf="operatingState$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.PROGRAM' | translate"
        [error]="feature | error"
        [isNgContent]="true"
        [editable]="true"
        [attr.data-feature]="feature.feature"
      >
        <div *ngIf="manualOrManualStillNextSchedule && (isManualMode || isManualTillNextSchedule)">
          <button
            data-at-open-manual-model-modal
            mat-stroked-button
            class="settings-btn-overlay"
            [viConfirm]="{
              title: '+INSTALLATIONS.INSTALLATION.MANUAL.MODE' | translate,
              content:
                '+INSTALLATIONS.INSTALLATION.BOILER.COMFORT_ENSURING_MODE.CONFIRM.DESCRIPTION'
                | translate,
              cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
              confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
            }"
            (confirm)="triggerManualMode()"
            (cancel)="cancelTriggerManualMode()"
          >
            <span>{{ '+INSTALLATIONS.INSTALLATION.SRC.STOP' | translate }}</span>
          </button>
        </div>

        <div>
          {{
            feature.properties?.reason?.value
              | translateOperatingState: feature.properties?.level?.value
          }}
        </div>
        <mat-icon
          class="edit-icon"
          appSrcModalManager="src-temperature-schedule-manager"
          [room]="room"
          (click)="selectRoom()"
          gtm="onOpen"
          gtmAction="Multiple days selection dialog"
          gtmCategory="room"
        >
          edit
        </mat-icon>
      </app-feature-list-item>

      <!-- room type -->
      <app-feature-list-item
        data-at-room-type
        *ngIf="room | executable: featureCommands.setType"
        [label]="'+INSTALLATIONS.INSTALLATION.SRC.ROOM_TYPE' | translate"
        [isNgContent]="true"
        [editable]="true"
        class="feature-list-item__select"
      >
        <mat-form-field
          mat-select-height-small
          class="room-panel__form-field"
          data-at-room-type-select
          *ngIf="room.commands?.setType?.params?.type?.constraints?.enum as types"
          gtm="onChange"
          gtmAction="Room type"
          gtmCategory="Select room type side panel"
        >
          <mat-select
            [value]="room.properties?.type?.value"
            (valueChange)="onRoomTypeChange($event)"
          >
            <mat-option *ngFor="let type of types" [value]="type" fieldTextContentTooltip>
              {{ type | translateRoom }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </app-feature-list-item>

      <app-feature-list-item
        data-at-room-type
        *ngIf="!(room | executable: featureCommands.setType)"
        [label]="'+INSTALLATIONS.INSTALLATION.SRC.ROOM_TYPE' | translate"
        [value]="room.properties?.type?.value | translateRoom"
      >
      </app-feature-list-item>

      <!-- room control mode -->
      <ng-container *ngIf="roomControlMode$ | async as feature">
        <ng-container
          *ngIf="feature | executable: featureCommands.setMode; else roomControlModeNonExecutable"
        >
          <app-feature-list-item
            data-at-room-control-mode
            *ngIf="feature?.commands?.setMode?.params?.mode?.constraints?.enum as commands"
            [isNgContent]="true"
            class="feature-list-item__select"
          >
            <div class="configuration-row gap-[8px]">
              <div
                *ngrxLet="uiService.isAboveMediumWidth$ as isAboveMediumWidth"
                class="flex flex-row items-center"
              >
                <span class="mr-[4px]"
                  >{{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.LABEL' | translate }}
                  <mat-icon
                    *ngIf="!isAboveMediumWidth"
                    class="info-icon"
                    (click)="openRoomModeModal()"
                  >
                    info
                  </mat-icon>
                </span>
                <!-- Put icon outside so flex wrapping works correctly -->
                <mat-icon
                  *ngIf="isAboveMediumWidth"
                  class="info-icon"
                  (click)="openRoomModeModal()"
                >
                  info
                </mat-icon>
              </div>
              <mat-form-field
                mat-select-height-small
                class="room-panel__form-field"
                data-at-room-control-mode-select
                gtm="onChange"
                gtmAction="Select room control mode"
                gtmCategory="room"
              >
                <mat-select
                  [value]="feature.properties?.value?.value"
                  (valueChange)="onRoomControlModeChange($event)"
                >
                  <mat-option
                    *ngFor="let command of commands"
                    [value]="command"
                    fieldTextContentTooltip
                  >
                    {{ command | translateRoomControlMode }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </app-feature-list-item>
        </ng-container>
        <ng-template #roomControlModeNonExecutable>
          <app-feature-list-item
            *ngIf="(feature?.properties?.value?.value ?? '') | translateRoomControlMode as featureValue"
            data-at-room-control-mode
            [label]="'+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.LABEL' | translate"
            [value]="featureValue"
          >
          </app-feature-list-item>
        </ng-template>
      </ng-container>

      <!-- heat up speed -->
      <ng-container *ngIf="heatUpSpeed$ | async | ready as feature">
        <app-feature-list-item
          data-at-program
          [label]="'+INSTALLATIONS.INSTALLATION.SRC.HEAT_UP_SPEED.TITLE' | translate"
          [error]="feature | error"
          [isNgContent]="true"
          [editable]="true"
          class="feature-list-item__select"
          [attr.data-feature]="feature.feature"
        >
          <mat-form-field
            mat-select-height-small
            class="room-panel__form-field"
            data-at-room-type-select
            *ngIf="feature.commands?.setValue?.params?.value?.constraints?.enum as types"
            gtm="onChange"
            gtmAction="Heat up speed type"
            gtmCategory="Select room heat up speed type side panel"
          >
            <mat-select
              [value]="feature.properties?.value?.value"
              [disabled]="!(feature | executable: 'setValue')"
              (valueChange)="onHeatUpSpeedChange($event)"
            >
              <mat-option *ngFor="let type of types" [value]="type">
                {{ type | translateRoomHeatUpSpeed }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </app-feature-list-item>
      </ng-container>

      <app-feature-list-item
        *ngIf="operatingState$ | async | ready as feature"
        data-at-room-current-condition
        [label]="'+INSTALLATIONS.INSTALLATION.SRC.CURRENT_CONDITION' | translate"
        [value]="feature.properties?.demand.value | translateOperatingStateDemand"
      >
      </app-feature-list-item>

      <!-- rooms.n.condensationRisk -->
      <ng-container *ngIf="condensationRisk$ | async | ready as feature">
        <app-feature-list-item
          data-at-room-condensation-risk
          *ngIf="feature.properties?.value?.value !== undefined"
          [label]="'+INSTALLATIONS.INSTALLATION.SRC.CONDENSATION' | translate"
          [value]="
            feature.properties.value.value
              ? ('+INSTALLATIONS.INSTALLATION.SRC.CONDENSATION_RISK' | translate)
              : ('+INSTALLATIONS.INSTALLATION.SRC.CONDENSATION_NO_RISK' | translate)
          "
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>
      </ng-container>

      <!-- co2 sensor target PPM -->
      <ng-container
        *ngIf="
          installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(
            roomId,
            srcType.AIR_QUALITY_SENSOR
          ) | async as devicesWithSensor
        "
      >
        <ng-container *ngIf="devicesWithSensor?.length">
          <ng-container *ngIf="roomCo2$ | async | ready as feature">
            <app-feature-list-item
              data-at-cs-sensor-temperature
              [error]="feature | error"
              [label]="'+INSTALLATIONS.SRC.AIR_QUALITY_SENSOR.TARGET_PPM' | translate"
              [isNgContent]="true"
              [editable]="feature.commands?.setConcentration?.isExecutable"
              class="feature-list-item__select"
              [attr.data-feature]="feature.feature"
            >
              <mat-form-field
                mat-select-height-small
                class="room-panel__form-field"
                gtm="onChange"
                gtmAction="Set target ppm concentration"
                gtmCategory="SRC air quality sensor panel"
              >
                <mat-select [formControl]="co2Concentration">
                  <mat-option
                    *ngFor="
                      let concentration of targetPPMRange(
                        feature.commands?.setConcentration?.params?.concentration?.constraints
                      )
                    "
                    [value]="concentration"
                  >
                    {{ concentration | suffix: SUFFIX.partsPerMillion }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="co2Concentration.hasError('required') || co2Concentration.hasError('min')"
                >
                  {{ '+INSTALLATIONS.INSTALLATION.SRC.NO_CO2_TARGET_VALUE' | translate }}
                </mat-error>
              </mat-form-field>
            </app-feature-list-item>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- childlock -->
      <ng-container *ngIf="childLock$ | async | ready as feature">
        <app-feature-list-item
          data-at-room-childlock
          [label]="'+INSTALLATIONS.INSTALLATION.SRC.CHILDLOCK' | translate"
          [error]="feature | error"
          [isNgContent]="true"
          [attr.data-feature]="feature.feature"
        >
          <app-pill
            class="childlock-pill"
            [type]="
              feature.properties.status.value === 'active' ? pillType.success : pillType.secondary
            "
          >
            {{
              (feature.properties.status.value === 'active' ? 'GENERAL.ON' : 'GENERAL.OFF')
                | translate
            }}
          </app-pill>
        </app-feature-list-item>
      </ng-container>

      <!-- configurationOpenWindow -->
      <ng-container *ngIf="configurationOpenWindow$ | async | ready as feature">
        <app-feature-list-item
          data-at-room-open-window
          [isNgContent]="true"
          [attr.data-feature]="feature.feature"
        >
          <div class="configuration-row gap-[8px]">
            <div class="flex flex-row items-center">
              <span class="mr-[4px]">{{
                '+INSTALLATIONS.INSTALLATION.SRC.CONFIGURATION_OPEN_WINDOW' | translate
              }}</span>
              <mat-icon
                class="info-icon"
                [matTooltip]="
                  '+INSTALLATIONS.INSTALLATION.SRC.CONFIGURATION_OPEN_WINDOW_TOOLTIP' | translate
                "
                matTooltipPosition="right"
              >
                info
              </mat-icon>
            </div>
            <mat-slide-toggle
              data-at-room-open-window-toggle
              gtm="onToggle"
              gtmAction="Switch open window"
              gtmCategory="room"
              (click)="onConfigurationOpenWindow(!feature.properties.active.value)"
              [checked]="feature.properties.active.value"
            >
            </mat-slide-toggle>
          </div>
        </app-feature-list-item>
      </ng-container>

      <app-room-related-heating-circuits
        *ngIf="devicesStore.isSelectedDeviceOBNG$ | async"
        [roomId]="roomId"
      >
      </app-room-related-heating-circuits>
    </app-feature-list-container>

    <ng-container
      *ngIf="
        installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(roomId, srcType.CS)
          | async as devices
      "
    >
      <app-feature-list-container *ngFor="let device of devices">
        <h3>{{ gatewayStore.getDeviceRoles(device.deviceId) | async | translateDeviceByRoles }}</h3>
        <app-cs-panel content [deviceId]="device.deviceId"></app-cs-panel>
      </app-feature-list-container>
    </ng-container>

    <ng-container
      *ngIf="
        installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(roomId, srcType.TRV)
          | async as devices
      "
    >
      <app-feature-list-container *ngFor="let device of devices">
        <h3>{{ gatewayStore.getDeviceRoles(device.deviceId) | async | translateDeviceByRoles }}</h3>
        <app-trv-panel content [deviceId]="device.deviceId" [roomId]="roomId"> </app-trv-panel>
      </app-feature-list-container>
    </ng-container>

    <ng-container
      *ngIf="
        installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(
          roomId,
          srcType.AIR_QUALITY_SENSOR
        ) | async as co2SensorDevices
      "
    >
      <app-feature-list-container *ngFor="let co2SensorDevice of co2SensorDevices">
        <h4 appHeader="4">
          {{
            gatewayStore.getDeviceRoles(co2SensorDevice.deviceId) | async | translateDeviceByRoles
          }}
        </h4>
        <app-air-quality-sensor-panel
          content
          [deviceId]="co2SensorDevice.deviceId"
          [roomId]="roomId"
        >
        </app-air-quality-sensor-panel>
      </app-feature-list-container>
    </ng-container>

    <ng-container
      *ngIf="
        installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(
          roomId,
          srcType.FHT_CHANNEL
        ) | async as devices
      "
    >
      <app-feature-list-container *ngFor="let device of devices">
        <h3>{{ gatewayStore.getDeviceRoles(device.deviceId) | async | translateDeviceByRoles }}</h3>
        <app-fht-channel-panel content [deviceId]="device.deviceId"></app-fht-channel-panel>
      </app-feature-list-container>
    </ng-container>

    <!-- Vitotrol 300E -->
    <ng-container
      *ngIf="
        installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(
          roomId,
          srcType.VITOTROL_300E
        ) | async as devices
      "
    >
      <app-feature-list-container *ngFor="let device of devices">
        <h3>{{ gatewayStore.getDeviceRoles(device.deviceId) | async | translateDeviceByRoles }}</h3>
        <app-cs-panel content [deviceId]="device.deviceId"></app-cs-panel>
      </app-feature-list-container>
    </ng-container>

    <!-- Vitotrol 100E -->
    <ng-container
      *ngIf="
        installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(
          roomId,
          srcType.VITOTROL_100E
        ) | async as devices
      "
    >
      <app-feature-list-container *ngFor="let device of devices">
        <h3>{{ gatewayStore.getDeviceRoles(device.deviceId) | async | translateDeviceByRoles }}</h3>
        <app-cs-panel content [deviceId]="device.deviceId"></app-cs-panel>
      </app-feature-list-container>
    </ng-container>
  </app-feature-details-grid>

  <app-banner *ngIf="!room?.properties?.actors?.value?.length" [type]="'warning'">
    {{ '+INSTALLATIONS.SRC.NO_DEVICES_ASSIGNED' | translate }}
  </app-banner>
</ng-container>
